export default "__VITE_ASSET__67418400__"